import { IConfig, IIconSetting } from 'hooks/useConfigHangDiem';
import Image from 'next/image';
import React from 'react';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import { getLinkProxyFile } from 'utils/ImageUtils';

interface IProps {
  type: 'new_product' | 'old_product' | 'cart' | 'quick_order' | '';
  replaceData: IConfig;
  iconHangDiem: IIconSetting;
  alt?: string;
}

const ReplaceHangDiem: React.FC<IProps> = (props) => {
  const { type, replaceData, iconHangDiem, alt } = props || {};
  switch (type) {
    case 'new_product':
      return <ImageFallbackStatic src={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} fallbackSrc={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} width={63} height={18} objectFit="contain" alt="hangdiem label product new"  />;
    case 'old_product':
      return <ImageFallbackStatic src={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} fallbackSrc={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} width={63} height={18} objectFit="contain"   alt="hang diem label product old" />
    case 'cart':
      return <img src={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} alt="label product hang diem" loading="lazy" />;
    case 'quick_order':
      return <img src={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} alt="label hang diem" />;
    default:
      return <img src={getLinkProxyFile(iconHangDiem?.horizontalIconSvg)} alt={alt ?? ""} />;
  }
};

export default ReplaceHangDiem;
